<ng-template #ModalEditarUsuario>
  <div class="modal-content">
    <div class="modal-header u-padding-vertical-0">
      <a>Editar Usuário</a>
      <mat-icon class="btn-fechar" (click)="fecharModal()">close</mat-icon>
    </div>

    <form [formGroup]="formEditaUsuario">
      <div>
        <label>Perfil</label>
        <select formControlName="idPerfil">
          <option class="options__cadastro" disabled="true" [ngValue]="0">
            Selecionar
          </option>
          <option *ngFor="let perfil of perfis.registros" [ngValue]="perfil.id">
            {{perfil.nome}}
          </option>
        </select>
        <app-mensagem-erro-input
          *ngIf="!formEditaUsuario.get('idPerfil')?.value && formEditaUsuario.get('idPerfil')?.touched">Perfil é
          obrigatório.</app-mensagem-erro-input>

        <div *ngIf="perfilSelecionado" class="informacoes-perfil-content" class="informacoes-perfil-content">
          <img class="icon-permissoes" (click)="listarPermissoes()" src="/assets/images/simbolos/information.svg"
            alt="Permissões do Perfil">
          <span class="perfil-label ml-5">Veja as permissões desse perfil</span>
        </div>

        <label>Nome</label>
        <input formControlName="nome" placeholder="Digite aqui">
        <app-mensagem-erro-input
          *ngIf="!formEditaUsuario.get('nome')?.value && formEditaUsuario.get('nome')?.touched">Nome é
          obrigatório.</app-mensagem-erro-input>
        <ng-container *ngIf="usuarioEdicao.tipoUsuario ==='EXT'">
          <label>Telefone</label>
          <input formControlName="telefone" placeholder="Digite aqui" mask="(00) 0000-0000">
          <app-mensagem-erro-input
            *ngIf="!formEditaUsuario.get('telefone')?.value && !formEditaUsuario.get('celular')?.value && formEditaUsuario.get('telefone')?.touched">É
            preciso informar pelo menos um número para contato.</app-mensagem-erro-input>
          <app-mensagem-erro-input
            *ngIf="formEditaUsuario.get('telefone')?.errors?.mask && formEditaUsuario.get('telefone')?.touched">Telefone
            inválido.</app-mensagem-erro-input>
          <label>Celular</label>
          <input formControlName="celular" placeholder="Digite aqui" mask="(00) 00000-0000">
          <app-mensagem-erro-input
            *ngIf="!formEditaUsuario.get('telefone')?.value && !formEditaUsuario.get('celular')?.value && formEditaUsuario.get('celular')?.touched">É
            preciso informar pelo menos um número para contato.</app-mensagem-erro-input>
          <app-mensagem-erro-input
            *ngIf="formEditaUsuario.get('celular')?.errors?.mask && formEditaUsuario.get('celular')?.touched">Celular
            inválido.</app-mensagem-erro-input>
          <ng-container *ngIf="!usuarioEdicao.codGrupoEconomico">
            <label>Contrato - Nome do Cliente</label>
            <app-select-all-options formControlName="codContrato" [opcoes]="contratos.registros"
              [valorOpcao]="valorOpcaoSelectContrato"
              [exibirOpcao]="exibirOpcaoSelectContrato(environment)"></app-select-all-options>
            <app-mensagem-erro-input
              *ngIf="formEditaUsuario.get('codContrato')?.value.length === 0 && formEditaUsuario.get('codContrato')?.touched">Ao
              menos um contrato deve ser informado.</app-mensagem-erro-input>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="token.tipoUsuario === 'INT'">
          <mat-checkbox name="alterarSenha" formControlName="alterarSenha">Alterar Senha</mat-checkbox>
          <ng-container *ngIf="formEditaUsuario.get('alterarSenha')?.value">
            <label for="senha">Senha</label>
            <input name="senha" formControlName="senha" type="password" autocomplete="new-password">
            <app-mensagem-erro-input
              *ngIf="formEditaUsuario.get('senha')?.errors?.required && formEditaUsuario.get('senha')?.touched">
              Este campo é obrigatório.
            </app-mensagem-erro-input>
            <app-mensagem-erro-input
              *ngIf="formEditaUsuario.get('senha')?.errors?.pattern && formEditaUsuario.get('senha')?.touched">
              Sua senha deve ter no mínimo 8 caracteres, sendo letras minusculas, maiúsculas, números e caracteres
              especiais.
            </app-mensagem-erro-input>
          </ng-container>
        </ng-container>
        <button [disabled]="formEditaUsuario.invalid" (click)="editarUsuario()" class="button-primary">
          Finalizar
        </button>

      </div>
    </form>
  </div>

</ng-template>

<app-modal-general *ngIf="perfilSelecionado" [showOrHideButton]="false" [showOrHideMessage]="false"
  [titulo]="'Permissões'" class="modal-listar-permissoes">
  <div class="modal-listagem-permissoes">
    <ul>
      <!--# Faturas (Financeiro) -->
      <!-- <li
        [ngClass]="perfilSelecionado.listarDemonstrativosFinanceiros ? 'permissao-existente' : 'permissao-inexistente'">
        Listar Demonstrativos Financeiros</li>
      <li
        [ngClass]="perfilSelecionado.exibirDetalhesDemonstrativoFinanceiro ? 'permissao-existente' : 'permissao-inexistente'">
        Exibir Detalhes de Demonstrativo Financeiro</li>
      <li [ngClass]="perfilSelecionado.realizarDownloadFechamento ? 'permissao-existente' : 'permissao-inexistente'">
        Realizar Download de Fechamento</li> -->

      <!--# Boletos (Financeiro) -->
      <!-- <li [ngClass]="perfilSelecionado.listarBoletos ? 'permissao-existente' : 'permissao-inexistente'">
        Listar Boletos</li>
      <li [ngClass]="perfilSelecionado.realizarDownloadBoleto ? 'permissao-existente' : 'permissao-inexistente'">
        Realizar Download de Boleto</li> -->

      <!--# Equipamentos (Serviços) -->
      <li [ngClass]="perfilSelecionado.listarEquipamentos ? 'permissao-existente' : 'permissao-inexistente'">
        Listar Equipamentos</li>
      <li
        [ngClass]="perfilSelecionado.realizarDownloadListagemEquipamentos ? 'permissao-existente' : 'permissao-inexistente'">
        Realizar Download de Listagem de Equipamentos</li>
      <li [ngClass]="perfilSelecionado.editarEquipamento ? 'permissao-existente' : 'permissao-inexistente'">
        Editar Equipamento</li>
      <li [ngClass]="perfilSelecionado.abrirChamadoEquipamento ? 'permissao-existente' : 'permissao-inexistente'">
        Abrir Chamado para Equipamento</li>
      <li [ngClass]="perfilSelecionado.visualizarChamadosEquipamento ? 'permissao-existente' : 'permissao-inexistente'">
        Visualizar Chamados do Equipamento</li>

      <!--# Histórico de Chamados (Serviços) -->
      <li [ngClass]="perfilSelecionado.listarChamadosAndamento ? 'permissao-existente' : 'permissao-inexistente'">
        Listar Chamados em Andamento</li>
      <li [ngClass]="perfilSelecionado.listarChamadosFinalizados ? 'permissao-existente' : 'permissao-inexistente'">
        Listar Chamados Finalizados</li>
      <li [ngClass]="perfilSelecionado.exibirDetalhesChamado ? 'permissao-existente' : 'permissao-inexistente'">
        Exibir Detalhes de Chamado</li>

      <!--# Novo Pedido (Suprimentos) -->
      <li [ngClass]="perfilSelecionado.abrirChamadoSuprimentos ? 'permissao-existente' : 'permissao-inexistente'">
        Abrir Chamado de Suprimentos</li>

      <!--# Histórico de Pedidos (Suprimentos) -->
      <li [ngClass]="perfilSelecionado.listarHistoricosPedidos ? 'permissao-existente' : 'permissao-inexistente'">
        Listar Históricos de Pedidos</li>
      <li [ngClass]="perfilSelecionado.exibirDetalhesPedido ? 'permissao-existente' : 'permissao-inexistente'">
        Exibir Detalhes de Pedido</li>

      <!--# Inventário -->
      <!-- <li [ngClass]="perfilSelecionado.listarInventarios ? 'permissao-existente' : 'permissao-inexistente'">
        Listar Inventários</li>
      <li [ngClass]="perfilSelecionado.exibirDetalhesInventario ? 'permissao-existente' : 'permissao-inexistente'">
        Exibir Detalhes de Inventário</li>
      <li [ngClass]="perfilSelecionado.alterarPosseInventario ? 'permissao-existente' : 'permissao-inexistente'">
        Alterar Posse de Inventário</li>
      <li
        [ngClass]="perfilSelecionado.realizarDownloadListagemInventario ? 'permissao-existente' : 'permissao-inexistente'">
        Realizar Download de Listagem de Inventário</li> -->

      <!--# Contratos -->
      <!-- <li [ngClass]="perfilSelecionado.listarContratos ? 'permissao-existente' : 'permissao-inexistente'">
        Listar Contratos</li>
      <li [ngClass]="perfilSelecionado.exibirDetalhesContrato ? 'permissao-existente' : 'permissao-inexistente'">
        Exibir Detalhes de Contrato</li>
      <li
        [ngClass]="perfilSelecionado.realizarDownloadListagemContrato ? 'permissao-existente' : 'permissao-inexistente'">
        Realizar Download de Listagem de Contrato</li>
      <li
        [ngClass]="perfilSelecionado.realizarDownloadEquipamentosContrato ? 'permissao-existente' : 'permissao-inexistente'">
        Realizar Download de Equipamentos do Contrato</li> -->

      <!--# Usuários -->
      <li [ngClass]="perfilSelecionado.listarUsuarios ? 'permissao-existente' : 'permissao-inexistente'">
        Listar Usuários</li>
      <li [ngClass]="perfilSelecionado.listarPerfis ? 'permissao-existente' : 'permissao-inexistente'">
        Listar Perfis</li>
      <li [ngClass]="perfilSelecionado.controlarUsuarios ? 'permissao-existente' : 'permissao-inexistente'">
        Controlar Usuários</li>
      <li [ngClass]="perfilSelecionado.controlarPerfis ? 'permissao-existente' : 'permissao-inexistente'">
        Controlar Perfis</li>
      <li [ngClass]="perfilSelecionado.gerenciarPermissoes ? 'permissao-existente' : 'permissao-inexistente'">
        Gerenciar Permissões</li>
    </ul>
  </div>
</app-modal-general>